module.exports = __webpack_public_path__ + "static/media/sup_fir_aid.ed4cdcaa.png";